export default "__VITE_ASSET__DpEpsLEx__"